<template>
   <el-dialog
      custom-class="dialog-wrapper"
      :title="dialogTitle"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      v-model="dialogVisible"
      width="680px"
   >
      <div class="form-wrapper">
         <el-form label-width="90px" label-position="left">
            <el-form-item label="渠道">
               <div class="channel-list">
                  <div class="channel-first-row">
                     <div v-for="item in firstRowChannels" :key="item.channel" class="channel-first-item">
                        <div class="channel-row">
                           <span class="channel-name">{{ item.channelLabel }}</span>
                           <el-switch v-model="item.isOpen"></el-switch>
                        </div>
                     </div>
                  </div>

                  <div v-for="item in otherChannels" :key="item.channel" class="channel-item channel-item-with-input">
                     <div class="channel-row">
                        <span class="channel-name">{{ item.channelLabel }}</span>
                        <el-switch v-model="item.isOpen"></el-switch>
                     </div>
                     <el-input
                        v-if="shouldRenderCodeInput(item)"
                        v-model="item.code"
                        size="small"
                        placeholder="输入口令"
                        class="channel-code-input"
                     ></el-input>
                  </div>
               </div>
            </el-form-item>

            <el-form-item label="手机系统">
               <el-select
                  v-model="formData.osType"
                  multiple
                  collapse-tags
                  placeholder="请选择手机系统"
                  class="full-width"
               >
                  <el-option label="Android" :value="0"></el-option>
                  <el-option label="iOS" :value="1"></el-option>
                  <el-option label="HarmonyOS" :value="2"></el-option>
               </el-select>
            </el-form-item>

            <el-form-item label="适用校区">
               <el-radio-group v-model="formData.allUnidFlag">
                  <el-radio :label="0">全量</el-radio>
                  <el-radio :label="1">部分</el-radio>
               </el-radio-group>
            </el-form-item>

            <el-form-item v-if="formData.allUnidFlag === 1" label="* 应用校区">
               <div class="campus-select-row">
                  <el-select
                     v-model="selectedCampus"
                     placeholder="请选择"
                     filterable
                     class="campus-select"
                  >
                     <el-option
                        v-for="(item, index) in campusDataSource"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                     ></el-option>
                  </el-select>
                  <el-button type="primary" size="small" @click="clickAddCampus">添加</el-button>
               </div>

               <div class="card-wrap">
                  <div v-for="item in selectedCampusList" :key="item.value" class="card-item">
                     <span>{{ item.label }}</span>
                     <el-button type="text" icon="circle-close" @click="clickDeleteCampus(item.value)"></el-button>
                  </div>
               </div>
               <div class="card-footer">一共 {{ selectedCampusList.length }} 个校区</div>
            </el-form-item>
         </el-form>
      </div>

      <template #footer>
         <div class="flex-row-center">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="clickSave">确定</el-button>
         </div>
      </template>
   </el-dialog>
</template>

<script>
const CHANNEL_CONFIG = [
   { label: '淘宝', value: 'TB-YDSJ', switchOnly: true },
   { label: '饿了么', value: 'SG-YDSJ', switchOnly: true },
   { label: '唯品会', value: 'VIP-YDSJ', switchOnly: true },
   { label: '京东电商', value: 'JD-E_COMMERCE', switchOnly: false },
   { label: '京东外卖', value: 'JD-FOOD_DELIVERY', switchOnly: false },
   { label: '美团外卖', value: 'MT-FOOD_DELIVERY', switchOnly: false },
];
const CHANNEL_VALUE_MAP = {
   '淘宝': 'TB-YDSJ',
   'TB-YDSJ': 'TB-YDSJ',
   '淘宝闪购': 'SG-YDSJ',
   '饿了么': 'SG-YDSJ',
   'SG-YDSJ': 'SG-YDSJ',
   '唯品会': 'VIP-YDSJ',
   'VIP-YDSJ': 'VIP-YDSJ',
   '京东老鞋': 'JD-E_COMMERCE',
   '京东电商': 'JD-E_COMMERCE',
   'JD-E_COMMERCE': 'JD-E_COMMERCE',
   '京东外卖': 'JD-FOOD_DELIVERY',
   'JD-FOOD_DELIVERY': 'JD-FOOD_DELIVERY',
   '美团外卖': 'MT-FOOD_DELIVERY',
   'MT-FOOD_DELIVERY': 'MT-FOOD_DELIVERY',
};
const SWITCH_ONLY_CHANNEL_VALUES = CHANNEL_CONFIG.filter((item) => item.switchOnly).map((item) => item.value);

export default {
   name: 'FengXiangTag',
   props: {
      dialogTitle: {
         type: String,
         default: '',
      },
      dataSource: {
         type: Object,
         default: () => ({}),
      },
      campusDataSource: {
         type: Array,
         default: () => [],
      },
   },
   data() {
      return {
         dialogVisible: false,
         selectedCampus: '',
         formData: {
            allUnidFlag: 0,
            osType: [],
            unidList: [],
         },
         channelList: [],
      };
   },
   computed: {
      firstRowChannels() {
         return this.channelList.filter((item) => SWITCH_ONLY_CHANNEL_VALUES.includes(item.channel));
      },

      otherChannels() {
         return this.channelList.filter((item) => !SWITCH_ONLY_CHANNEL_VALUES.includes(item.channel));
      },

      selectedCampusList() {
         if (!this.formData.unidList || this.formData.unidList.length === 0) {
            return [];
         }
         return this.formData.unidList
            .map((unid) => {
               const campus = this.campusDataSource.find((item) => item.value === unid || item.value === Number(unid));
               if (campus) {
                  return campus;
               }
               return {
                  label: String(unid),
                  value: unid,
               };
            })
            .filter((item) => !!item);
      },
   },
   watch: {
      dataSource: {
         handler(newVal) {
            if (this.dialogVisible) {
               this.initFormByDataSource(newVal);
            }
         },
         deep: true,
      },
   },
   methods: {
      getChannelLabel(channelValue) {
         const channel = CHANNEL_CONFIG.find((item) => item.value === channelValue);
         return channel ? channel.label : channelValue;
      },

      normalizeChannelName(channel) {
         const name = (channel || '').trim();
         return CHANNEL_VALUE_MAP[name] || name;
      },

      parseSwitchValue(value) {
         if (typeof value === 'number') {
            return value === 1;
         }
         if (typeof value === 'boolean') {
            return value;
         }
         if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase();
            if (['1', 'true', 'on', 'open', '开启'].includes(normalized)) {
               return true;
            }
            return false;
         }
         if (Number(value) === 1) {
            return true;
         }
         return false;
      },

      parseResValue(rawValue) {
         if (!rawValue) {
            return {};
         }
         let currentValue = rawValue;
         for (let i = 0; i < 4; i++) {
            if (currentValue && typeof currentValue === 'object') {
               return currentValue;
            }
            if (typeof currentValue !== 'string') {
               return {};
            }
            const sourceText = currentValue.trim();
            if (!sourceText) {
               return {};
            }
            try {
               currentValue = JSON.parse(sourceText);
               continue;
            } catch (error) {
               try {
                  const decodedText = decodeURIComponent(sourceText);
                  if (decodedText !== sourceText) {
                     currentValue = decodedText;
                     continue;
                  }
               } catch (decodeError) {
                  console.log('FENG_XIANG_TAG-解析数据失败:', decodeError);
               }
               console.log('FENG_XIANG_TAG-解析数据失败:', error);
               return {};
            }
         }
         return currentValue && typeof currentValue === 'object' ? currentValue : {};
      },

      parseChannels(rawChannels) {
         if (Array.isArray(rawChannels)) {
            return rawChannels;
         }
         const parsedChannels = this.parseResValue(rawChannels);
         if (Array.isArray(parsedChannels)) {
            return parsedChannels;
         }
         if (parsedChannels && typeof parsedChannels === 'object') {
            return Object.keys(parsedChannels).map((channelName) => ({
               channel: channelName,
               code: parsedChannels[channelName] && parsedChannels[channelName].code ? parsedChannels[channelName].code : '',
               isOpen: parsedChannels[channelName] && parsedChannels[channelName].isOpen !== undefined
                  ? parsedChannels[channelName].isOpen
                  : parsedChannels[channelName],
            }));
         }
         return [];
      },

      shouldShowCodeInput(channel) {
         return !SWITCH_ONLY_CHANNEL_VALUES.includes(channel);
      },

      shouldRenderCodeInput(item) {
         return this.shouldShowCodeInput(item.channel) && !!item.isOpen;
      },

      getDefaultChannelList() {
         return CHANNEL_CONFIG.map((channel) => ({
            channel: channel.value,
            channelLabel: channel.label,
            code: '',
            isOpen: false,
         }));
      },

      initFormByDataSource(dataSource) {
         this.resetForm();
         console.log('FENG_XIANG_TAG-initFormByDataSource-dataSource:', dataSource);
         if (dataSource && dataSource.resValue) {
            console.log('FENG_XIANG_TAG-initFormByDataSource-rawResValue:', dataSource.resValue);
            const resValue = this.parseResValue(dataSource.resValue);
            console.log('FENG_XIANG_TAG-initFormByDataSource-parsedResValue:', resValue);
            const channelMap = {};
            const channels = this.parseChannels(resValue.channels);
            console.log('FENG_XIANG_TAG-initFormByDataSource-parsedChannels:', channels);
            channels.forEach((item) => {
               if (!item || !item.channel) {
                  return;
               }
               const channelName = this.normalizeChannelName(item.channel);
               channelMap[channelName] = {
                  channel: channelName,
                  channelLabel: this.getChannelLabel(channelName),
                  code: item.code || '',
                  isOpen: this.parseSwitchValue(item.isOpen),
               };
            });
            console.log('FENG_XIANG_TAG-initFormByDataSource-channelMap:', channelMap);
            this.channelList = CHANNEL_CONFIG.map((channel) => {
               if (channelMap[channel.value]) {
                  return channelMap[channel.value];
               }
               return {
                  channel: channel.value,
                  channelLabel: channel.label,
                  code: '',
                  isOpen: false,
               };
            });
            console.log('FENG_XIANG_TAG-initFormByDataSource-finalChannelList:', this.channelList);

            this.formData.allUnidFlag = Number(resValue.allUnidFlag) === 1 ? 1 : 0;
            this.formData.osType = Array.isArray(resValue.osType)
               ? resValue.osType.map((item) => Number(item)).filter((item) => [0, 1, 2].includes(item))
               : [];
            this.formData.unidList = this.formData.allUnidFlag === 1 && Array.isArray(resValue.unidList)
               ? resValue.unidList
               : [];
            console.log('FENG_XIANG_TAG-initFormByDataSource-finalFormData:', this.formData);
         } else {
            console.log('FENG_XIANG_TAG-initFormByDataSource-emptyResValue');
         }
      },

      clickEdit(sourceData) {
         console.log('FENG_XIANG_TAG-clickEdit-sourceData:', sourceData);
         console.log('FENG_XIANG_TAG-clickEdit-propDataSource:', this.dataSource);
         this.initFormByDataSource(sourceData || this.dataSource);
         this.dialogVisible = true;
      },

      resetForm() {
         this.selectedCampus = '';
         this.channelList = this.getDefaultChannelList();
         this.formData = {
            allUnidFlag: 0,
            osType: [],
            unidList: [],
         };
      },

      clickAddCampus() {
         if (!this.selectedCampus && this.selectedCampus !== 0) {
            this.$util.errorMsg('请选择校区');
            return;
         }
         const hasCampus = this.formData.unidList.some((item) => item === this.selectedCampus || item === Number(this.selectedCampus));
         if (hasCampus) {
            this.$util.errorMsg('该校区已添加');
            return;
         }
         this.formData.unidList = [...this.formData.unidList, this.selectedCampus];
         this.selectedCampus = '';
      },

      clickDeleteCampus(campusId) {
         this.formData.unidList = this.formData.unidList.filter((item) => item !== campusId && Number(item) !== Number(campusId));
      },

      clickSave() {
         if (!this.formData.osType.length) {
            this.$util.errorMsg('请选择手机系统');
            return;
         }
         if (this.formData.allUnidFlag === 1 && this.formData.unidList.length === 0) {
            this.$util.errorMsg('请至少添加一个校区');
            return;
         }

         const value = {
            allUnidFlag: this.formData.allUnidFlag,
            channels: this.channelList.map((item) => ({
               channel: item.channel,
               code: this.shouldShowCodeInput(item.channel) ? (item.code || '') : '',
               isOpen: item.isOpen ? 1 : 0,
            })),
            osType: this.formData.osType.map((item) => Number(item)),
            unidList: this.formData.allUnidFlag === 1 ? this.formData.unidList : [],
         };

         const param = {
            tag: this.dataSource.tag,
            key: this.dataSource.resKey,
            value: JSON.stringify(value),
         };

         this.$http({
            url: this.$util.domain + '/adminapi/v1/tools/addOrUpdateConfig',
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(param),
         }).then((res) => {
            if (res.data.error === 10000) {
               this.dialogVisible = false;
               this.$emit('refresh');
               this.$util.successMsg('保存成功');
            } else {
               this.$util.errorMsg(res.data.message || '保存失败');
            }
         }).catch((error) => {
            console.log('粉象口令植入-保存失败:', error);
            this.$util.errorMsg('保存失败');
         });
      },
   },
};
</script>

<style scoped>
.channel-list {
   padding: 0;
}

.channel-first-row {
   display: flex;
   align-items: center;
   gap: 32px;
}

.channel-first-item {
   flex: none;
}

.channel-item-with-input + .channel-item-with-input {
   margin-top: 8px;
}

.channel-row {
   display: flex;
   align-items: center;
   justify-content: flex-start;
   gap: 10px;
}

.channel-name {
   color: #303133;
   font-size: 14px;
}

.channel-code-input {
   margin-top: 6px;
}

.full-width {
   width: 100%;
}

.campus-select-row {
   display: flex;
   align-items: center;
}

.campus-select {
   flex: 1;
   margin-right: 8px;
}

.card-wrap {
   width: 100%;
   min-height: 120px;
   margin: 8px 0 4px;
   padding: 10px;
   box-sizing: border-box;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   overflow: auto;
}

.card-footer {
   text-align: right;
   font-size: 14px;
   line-height: 1.5;
}

.card-item {
   display: inline-block;
   margin: 4px;
   padding: 0 4px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
}

.flex-row-center {
   display: flex;
   justify-content: center;
   align-items: center;
}
</style>



// WEBPACK FOOTER //
// FengXiangTag.vue?7966be28